import React, { useEffect } from "react";
import Helmet from "react-helmet";
import HomepageLayout from "src/layouts/homepage";
import JSONData from "branding/site-metadata.json";
import RawFooter from "@tightrope/footerlinks/rawfooter.js"
import footerStyles from 'src/styles/shared/footer.module.scss';
import styles from 'src/styles/shared/legal-pages.module.scss';

export default function Privacy() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://app.termly.io/embed-policy.min.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return (
        <HomepageLayout>
            <Helmet data={JSONData}>
            <link rel="icon" href="/img/favicon.png" sizes="32x32" />
            <title>Privacy Policy | AllSearch</title></Helmet>
            <div className={styles.legalPage}>
            <header style={{backgroundImage: "#eaf5ef", border: "1px solid #4e5052"}}>
            <img src="/img/allsearch-logo.svg" alt="AllSearch Logo" />
                </header>
                <div className={styles.container}>
                    <div
                        name="termly-embed"
                        data-id="24b80033-9965-4163-83ae-9b745d07fa39"
                        data-type="iframe"
                    ></div>
                </div>
            </div>
            <RawFooter />
        </HomepageLayout>
    );
}
